import { createStyles, Grid, TextField, Theme, withStyles, WithStyles } from '@material-ui/core'
import * as React from 'react'

interface AcademicAwardDetailsProps extends WithStyles<typeof styles> {
	value: string
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const AcademicAwardDetails: React.FC<AcademicAwardDetailsProps> = (props: AcademicAwardDetailsProps) => {
	const { classes, onChange, value } = props

	return (
		<Grid container={true} spacing={8}>
			<Grid item={true} xs={12} md={3} className={classes.dropdownLabel}>
				Other Details&#58;
			</Grid>
			<Grid item={true} xs={12} md={9}>
				<TextField
					multiline={true}
					rows={3}
					name="academicAwardDetail"
					className={classes.dropdown}
					value={value}
					onChange={onChange}
					margin="dense"
					variant="outlined"
					InputProps={{
						inputProps: {
							pattern: "^([a-zA-Z0-9]|[- @\\.#'&!])*$",
						},
					}}
				/>
			</Grid>
		</Grid>
	)
}

const styles = (theme: Theme) =>
	createStyles({
		dropdownLabel: {
			display: 'flex',
			justifyContent: 'flex-end',
			alignItems: 'baseline',
			paddingTop: '12px',
			[theme.breakpoints.down('sm')]: {
				justifyContent: 'flex-start',
			},
		},
		dropdown: {
			display: 'flex',
			flex: 1,
		},
	})

export default withStyles(styles)(AcademicAwardDetails)
